if (!customElements.get('ae-salamander')) {
  customElements.define('ae-salamander', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-sala-interest]');
        if (!trigger) return;
        const select = this.querySelector('#SalaInterest');
        if (!select) return;
        const option = Array.from(select.options).find(item => item.value === trigger.dataset.salaInterest);
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });
}
